import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { GECKO_CONSTS, GeckoField } from 'ui';
import Phone from 'react-phone-number-input';

import GeckoDates from 'services/gecko-date';
import DraftDisplay from 'components/DraftDisplay';
import {
  allSelectableOptions,
  onlyUnarchivedSelectableOptions,
} from 'utilities/customFieldUtils';

import 'react-phone-number-input/style.css';

class CustomFieldInput extends Component {
  static propTypes = {
    field: PropTypes.shape({
      type: PropTypes.string,
    }),
    onChange: PropTypes.func,
    value: PropTypes.any,
    archivedOptionsEnabled: PropTypes.bool,
  };

  static defualtProps = {
    field: {
      type: GECKO_CONSTS.FIELD_TYPE_TEXT,
    },
    archivedOptionsEnabled: false,
  };

  componentWillReceiveProps(nextProps) {
    const requiresChange = [
      'tel',
      'telephone',
      'date',
      'display',
      GECKO_CONSTS.FIELD_TYPE_SELECT,
      GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI,
    ];
    if (
      this.props.field.type !== nextProps.field.type &&
      (requiresChange.includes(this.props.field.type) ||
        requiresChange.includes(nextProps.field.type))
    ) {
      this.props.onChange('');
    }
  }

  getField(field) {
    const base = {
      key: 'value',
    };
    if (field.type === 'tel' || field.type === 'telephone') {
      return Object.assign({}, base, {
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        component: <Phone placeholder="Enter phone number" />,
      });
    }
    if (field.type === 'date') {
      return Object.assign({}, base, {
        type: GECKO_CONSTS.FIELD_TYPE_DATE,
        format: 'X',
        enableUTC: true,
        display_format: new GeckoDates().FORMATS.SHORT,
        placeholder: new GeckoDates().FORMATS.SHORT,
      });
    }
    if (field.type === 'display') {
      return Object.assign({}, base, {
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        component: <DraftDisplay editorObject={field.editor_object} />,
      });
    }
    if (field.type === 'textarea') {
      return Object.assign({}, base, {
        type: GECKO_CONSTS.FIELD_TYPE_TEXTAREA,
        autoResize: true,
      });
    }
    // Default to field type
    return Object.assign({}, base, {
      type: field.type,
      options: this.props.archivedOptionsEnabled
        ? allSelectableOptions(field.field_options)
        : onlyUnarchivedSelectableOptions(field.field_options),
    });
  }

  handleChange(_key, value) {
    this.props.onChange(value);
  }

  render() {
    const field = this.getField(this.props.field);
    const values = { value: this.props.value };
    return (
      <div className="CustomFieldInput">
        <GeckoField
          field={field}
          values={values}
          handler={this.handleChange.bind(this)}
        />
      </div>
    );
  }
}

export default CustomFieldInput;
